import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { isNil } from 'ramda';

import {
  createMerchantName,
  deleteMerchantName,
} from '../../../../../../../mutations/MerchantNames';
import StorePresenter from '../../../../../../../presenters/StorePresenter';
import MerchantNamePresenter from '../../../../../../../presenters/MerchantNamePresenter';
import Modal from '../../../../../../../components/Modal';
import { StoreProvider, Label, Dialog } from '../../../../../../../components';

import MerchantNamesTable from './components/MerchantNamesTable';

const MerchantNamesView = (props) => {
  const {
    storeId,
    storeLists,
    relay: { environment },
  } = props;
  const { merchantNames } = storeLists;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [merchantName, setMerchantName] = useState({ storeId });
  const [editedMerchantName, setEditedMerchantName] = useState({});
  const [errors, setErrors] = useState(null);
  const handleDeleteDialogOpen = (merchantName) => {
    setEditedMerchantName(merchantName);
    setIsDeleteDialogOpen(true);
  };
  const handleDeleteDialogClose = () => {
    setEditedMerchantName({});
    setIsDeleteDialogOpen(false);
  };

  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => {
    setMerchantName({ storeId });
    setErrors(null);
    setIsModalOpen(false);
  };

  const handleMerchantNameChange = ({ target }) => {
    const { id, value } = target;

    setMerchantName({ ...merchantName, [id]: value });
  };

  const handleMerchantNameSave = () => {
    createMerchantName(environment, merchantName, storeLists.id, storeId, {
      onCompleted: handleSubmitSuccess,
      onError: (error) => console.error(`commit failed: ${error}`),
    });
  };

  const handleDeleteMerchantName = () => {
    const params = {
      storeId,
      id: MerchantNamePresenter.id(editedMerchantName),
    };
    deleteMerchantName(environment, params, storeLists.id, {
      onCompleted: handleDeleteDialogClose,
      onError: (error) => console.error(`commit failed: ${error}`),
    });
  };

  const handleSubmitSuccess = (response) => {
    const {
      createMerchantName: { errors },
    } = response;
    if (!isNil(errors)) {
      setErrors(errors);
    } else {
      handleModalClose();
    }
  };

  return (
    <div>
      <Dialog
        className="deletion"
        isOpen={isDeleteDialogOpen}
        message={`This will delete merchant name ${MerchantNamePresenter.name(
          merchantName
        )}. Do you want to proceed?`}
        onConfirm={handleDeleteMerchantName}
        onCancel={handleDeleteDialogClose}
      />
      <Modal
        title="Add Merchant Name"
        isModalOpen={isModalOpen}
        onClose={handleModalClose}
      >
        <div className="row">
          <div className="input">
            <Label attr="name" text="Name" errors={errors} />
            <input
              type="text"
              id="name"
              value={MerchantNamePresenter.name(merchantName) || ''}
              onChange={handleMerchantNameChange}
              required
            />
          </div>
        </div>
        <div className="modal-actions">
          <button
            className="modal-save"
            type="submit"
            onClick={handleMerchantNameSave}
          >
            Save Changes
          </button>
          <button className="modal-close" onClick={handleModalClose}>
            Cancel
          </button>
        </div>
      </Modal>
      <div className="brand-field">
        <h4>Merchant Names</h4>
        <div className="form-header-actions">
          <div className="add-tags-field">
            <button className="button -add-button" onClick={handleModalOpen}>
              Add Merchant Name
            </button>
          </div>
        </div>
        <MerchantNamesTable
          merchantNames={merchantNames}
          onDeleteButtonClick={handleDeleteDialogOpen}
        />
      </div>
    </div>
  );
};

const MerchantNamesContainer = createFragmentContainer(MerchantNamesView, {
  storeLists: graphql`
    fragment MerchantNames_storeLists on StoreLists {
      id
      merchantNames(storeId: $storeId) {
        id
        name
      }
    }
  `,
});

const MerchantNames = (props) => {
  const { brand } = props;

  const preprocessParams = () => {
    const variables = {
      storeId: StorePresenter.id(brand),
    };

    return variables;
  };
  return (
    <StoreProvider
      container={MerchantNamesContainer}
      modern
      preprocessParams={preprocessParams}
      storeId={StorePresenter.id(brand)}
      query={graphql`
        query MerchantNamesQuery($storeId: ID!) {
          storeLists {
            ...MerchantNames_storeLists
          }
        }
      `}
    />
  );
};

export default MerchantNames;
